import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DetailRow } from '@shared/components/detail-row/detail-row';
import { NttButton } from '@ui/button';
import { AmountPipe, CartItemRow, CartItemViewModel } from '@shared';
import { NttDropdownMenu } from '@ui/dropdown-menu';
import {
  CartItem,
  cartItemDisplayName,
} from '@shared/services/shopping-cart/cart-item.model';

@Component({
  selector: 'bcm-cart-dropdown-content',
  imports: [RouterLink, DetailRow, NttButton, AmountPipe, CartItemRow],
  templateUrl: './cart-dropdown-content.html',
  styleUrl: './cart-dropdown-content.scss',
})
export class CartDropdownContent {
  readonly items = input.required<CartItem[]>();
  readonly totalPayableAmount = input.required<string>();
  readonly currencyName = input.required<string>();
  private readonly _dropdownMenu = inject(NttDropdownMenu, { optional: true });

  protected toViewModel(item: CartItem): CartItemViewModel {
    const gc = item.giftCard;
    const b = item.bundle;
    return {
      productName: cartItemDisplayName(item),
      productType: gc ? 'گیفت کارت' : 'باندل',
      quantity: String(gc?.quantity ?? b?.quantity ?? 0),
      totalAmount: gc ? String(Number(gc.amount) * gc.quantity) : '',
      currencyName:
        gc?.currency?.name ?? b?.giftCards?.[0]?.currency?.name ?? '',
      logoUrl: gc?.providerLogoUrl ?? b?.logoUrl ?? null,
      shoppingCartItemId: item.shoppingCartItemId,
      serviceProviderItemId: gc?.serviceProviderItemId,
      bundleId: b?.bundleId,
      requestAmount: gc?.amount,
    };
  }

  protected closeMenu(): void {
    this._dropdownMenu?.close();
  }
}
